export default {
  // Tiêu đề trang
  title: "Bản ghi đẩy",
  
  // Biểu mẫu tìm kiếm
  searchForm: {
    pushTime: "Thời gian đẩy",
    pushTimePlaceholder: "Vui lòng chọn khoảng thời gian",
    memberAccount: "Thành viên đẩy",
    memberAccountPlaceholder: "Vui lòng nhập",
    memberType: "Loại thành viên",
    memberTypePlaceholder: "Vui lòng chọn",
    search: "Truy vấn",
    reset: "Đặt lại"
  },
  
  // Tiêu đề cột bảng
  table: {
    memberAccount: "Thành viên đẩy",
    memberType: "Loại thành viên",
    pushTitle: "Tiêu đề đẩy",
    pushContent: "Nội dung đẩy",
    pushTime: "Thời gian đẩy",
    status: "Trạng thái",
    createTime: "Thời gian tạo"
  },
  
  // Loại thành viên
  memberType: {
    specify: "Thành viên được chỉ định",
    agent: "Đại lý",
    import: "Nhập tài liệu",
    all: "Tất cả thành viên"
  },
  
  // Trạng thái
  status: {
    pending: "Chờ đẩy",
    success: "Đẩy thành công",
    failed: "Đẩy thất bại"
  },
  
  // Phân trang
  pagination: {
    total: "Tổng {total} bản ghi",
    pageInfo: "Trang {currentPage}/{totalPages}",
    itemsPerPage: "mục/trang",
    jumpTo: "Chuyển đến",
    page: "trang"
  },
  
  // Tin nhắn
  messages: {
    fetchDataFailed: "Không thể tải dữ liệu",
    noData: "Không có dữ liệu",
    timeRangeExceeded: "Phạm vi thời gian truy vấn không được vượt quá 1 tháng, vui lòng chọn lại."
  }
};
